<template>
    <div>
        <supa-base-header-sec></supa-base-header-sec>
        <div class="container-fluid base-container">
            <div class="base-box base-box__table-sec">
                <table class="table  table-striped table-sm table-slglrs">
                    <thead>
                        <tr>
                            <th style="padding-left: 50px;">Назив суда</th>
                            <th>Ознака и број предмета</th>
                            <th>Ближе одређење материје / назив</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in supaList" v-bind:key="index">
                            <td>{{ row.courtName }}</td>
                            <td>
                                <!--                            <a :href="'http://pravno-informacioni-sistem.rs/SlGlasnikPortal/supa/viewAct/'+row.url"-->
                                <!--                               target="_blank">-->
                                <!--                                {{row.subjectId}}-->
                                <!--                            </a>-->
                                <!--                            http://10.10.30.99:8080/SlGlasnikPortal/supa/viewAct/1f51ee9a-b7c0-ae68-f6e6-89486a943755-->
                                <router-link v-if="canOpen === 'can_open'" :to="{ path: '/supa/viewAct/' + row.id }"
                                    target="_blank">{{
                                        row.subjectId
                                    }}</router-link>
                                <a v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                    {{ row.subjectId }}
                                </a>
                                <a v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                    {{ row.subjectId }}
                                </a>
                            </td>
                            <td>
                                <router-link target="_blank" v-if="canOpen === 'can_open'"
                                    :to="{ path: '/supa/viewAct/' + row.id }">{{
                                        row.name
                                    }}</router-link>
                                <a v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                    {{ row.name }}
                                </a>
                                <a v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                    {{ row.name }}
                                </a>


                                <!--                            <a :href="'http://pravno-informacioni-sistem.rs/SlGlasnikPortal/supa/viewAct/'+row.url">-->
                                <!--                                target="_blank">{{row.name}}-->
                                <!--                            </a>-->
                            </td>
                        </tr>
                    </tbody>

                </table>
                <!--                <pre>-->
                <!--                    {{supaList}}-->
                <!--                </pre>-->

            </div>

        </div>

    </div>
</template>

<script>

import SupaBaseHeaderSec from '@/base_pages/supa/SupaBaseHeaderSec.vue';
import axios from 'axios';
import { mapState } from 'vuex';


export default {
    name: "SupaLatestPage.vue",
    data() {
        return {
            supaList: null,
            baseApiUrl: window.env.VUE_APP_API_SP_DEV,
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        SupaBaseHeaderSec,
    },
    computed: {
        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('SP')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios
                .get(this.baseApiUrl + 'prins/supa/latestActs')
                .then(response => {
                    this.supaList = response.data;
                }).catch(function (error) {
                    console.log(error);
                });
        }
    },
    mounted() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_supa';
    }
}
</script>

<style scoped></style>
